// All Regexes
/* eslint-disable no-useless-escape */
const emailRegex = new RegExp(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/);
const nameRegex = new RegExp(/^[a-zA-Z ]{2,50}$/);
const bankAccountNumberRegex = new RegExp(/^[0-9]{9,18}$/);
const upiIdRegex = new RegExp(/^[a-zA-Z0-9.\\-_]{2,256}@[a-zA-Z]{2,64}$/);
const ifscCodeRegex = new RegExp(/^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/);
const contactNumberRegex = new RegExp(/^[0-9]{10}$/);
const yearRegex = new RegExp(/^[0-9]{4}$/);
const pincodeRegex = new RegExp(/^[0-9]{6}$/);
/* eslint-enable no-useless-escape */

const validateEmail= (email: string): {status: boolean, error: string} => {
    if(!emailRegex.test(email))
        return {
            status: false,
            error: "Please enter a valid email"
        }
    else 
        return {
            status: true,
            error: ""
        }
}

const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_MAX_LENGTH = 64;

const validatePassword = (password: string): {status: boolean, error: string} => {
    if (password.length < PASSWORD_MIN_LENGTH)
        return {
            status: false,
            error: `Password must have at least ${PASSWORD_MIN_LENGTH} characters`
        }
    if (password.length > PASSWORD_MAX_LENGTH)
        return {
            status: false,
            error: `Password must not exceed ${PASSWORD_MAX_LENGTH} characters`
        }
    if (!/[a-z]/.test(password))
        return {
            status: false,
            error: "Password must contain at least one lowercase letter"
        }
    if (!/[A-Z]/.test(password))
        return {
            status: false,
            error: "Password must contain at least one uppercase letter"
        }
    if (!/\d/.test(password))
        return {
            status: false,
            error: "Password must contain at least one number"
        }
    if (!/[^A-Za-z0-9]/.test(password))
        return {
            status: false,
            error: "Password must contain at least one special character"
        }
    return {
        status: true,
        error: ""
    }
}

const validateName = (name: string): boolean => {
    return nameRegex.test(name);
}

const validateBankAccountNumber = (accountNumber: string): boolean => {
    return bankAccountNumberRegex.test(accountNumber);
}

const validateUPIId = (upiId: string): boolean => {
    return upiIdRegex.test(upiId);
}

const validateIFSCCode = (ifscCode: string): boolean => {
    return ifscCodeRegex.test(ifscCode);
}

const validateContactNumber = (contactNumber: string): boolean => {
    return contactNumberRegex.test(contactNumber);
}

const validateYear = (year: string):boolean => {
    return yearRegex.test(year);
}

const validatePincode = (pincode: string):boolean => {
    return pincodeRegex.test(pincode);
}

export {validateEmail, 
        validatePassword, 
        validateName,
        validateBankAccountNumber,
        validateUPIId,
        validateIFSCCode,
        validateContactNumber,
        validateYear,
        validatePincode
    };